import {useLocation,useNavigate} from 'react-router-dom';
import {parentFor,safeInternal,canNavigate} from './navigation';
export function useSafeBack(user) {
  const nav=useNavigate(), loc=useLocation();
  return () => {
    const target=safeInternal(new URLSearchParams(loc.search).get('returnTo'));
    if (target && target !== loc.pathname + loc.search && canNavigate(user,target)) {
      nav(target,{replace:true});
    } else if(window.history.state?.idx>0) nav(-1);
    else nav(parentFor(loc.pathname,user),{replace:true});
  };
}
